<template>
    <modal-component v-show="isShow" @modalOk="onOk" @modalNo="onClose" @afterLeave="onAfterLeave">
        <h4 slot="header">{{ title }}</h4>
        <h3 slot="body" style="text-align:center;">
            <p class="tc pb2em" style="margin-top:0.5em;">
                <strong>{{ message }}</strong>
            </p>
        </h3>
    </modal-component>
</template>
<script>
    import ModalComponent from './ModalComponent';

    export default {
        components: {
            ModalComponent,
        },

        data: function() {
            return {
                title: "",
                message: "",
                isShow: true,
            };
        },

        methods: {
            show: function ()
            {
                this.$mount();
                document.body.appendChild( this.$el );
            },

            destroy: function ()
            {
                document.body.removeChild( this.$el );
                this.$destroy();
            },

            onOk: function ()
            {
                this.isShow = false;
            },

            onClose: function ()
            {
                this.isShow = false;
            },

            onAfterLeave: function ()
            {
                this.destroy();
            }
        }
    }
</script>
